<template>
  <Teleport to="#modals">
    <Modal v-if="showNotification">
      <template #header-all>
        <h2>
          Коллеги, в ближайшее время мы подключим двухфакторную аутентификацию
          (2FA) для повышения безопасности сервиса.
        </h2>
        <br />
        <p>Чтобы обеспечить вам бесперебойный доступ:</p>
        <ul class="notification-list">
          <li>
            <span class="notification-highlight-1">Сохраните/ запишите</span>
            себе ваш логин:
            <span class="notification-highlight-2">{{
              store.state.auth.me?.username
            }}</span>
          </li>
          <li>
            После включения 2FA вы получите одноразовый временный пароль по
            email
          </li>
        </ul>
        <p>Рекомендуем сохранить эту информацию в надежном месте.</p>
      </template>
      <template #content>
        <button class="btn btn-next btn-wide" @click="handleClose">
          Понятно
        </button>
      </template>
    </Modal>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue'
import Modal from '@/components/Modal.vue'
import {
  wasNotificationShown,
  markNotificationAsShown,
} from '@/utils/notification'
import { useStore } from 'vuex'

const TWO_FACTOR_NOTIFICATION_KEY = 'two_factor_notification_shown'

const store = useStore()
const showNotification = ref(false)

const hasTargetRoles = (roles) => {
  if (!roles || !Array.isArray(roles)) {
    return false
  }

  return roles.some((role) => role === 'ldfd' || role === 'traderegion')
}

const handleClose = () => {
  markNotificationAsShown(TWO_FACTOR_NOTIFICATION_KEY)
  showNotification.value = false
}

watch(
  () => store.state.auth.me,
  (user) => {
    if (
      user &&
      hasTargetRoles(user.roles) &&
      !wasNotificationShown(TWO_FACTOR_NOTIFICATION_KEY)
    ) {
      showNotification.value = true
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.notification-content {
  display: grid;
  gap: 8px;
}

.notification-list {
  list-style-type: disc;
  padding-left: 15px;
}

.notification-highlight-1 {
  font-weight: 700;
  text-decoration: underline;
}

.notification-highlight-2 {
  font-weight: 700;
  color: #1a3a6c;
}
</style>
